import { ResponseKpi } from './types';
import { http } from '../../http';

export const getKpi = async () => {
    const data = await http.get<ResponseKpi, ResponseKpi>('/kpi');
    return data;
};
